import { HeatmapLayer, HeatmapLayerProps } from "@deck.gl/aggregation-layers"
import type { DefaultProps } from "@deck.gl/core"
import { AnyAction, SidePanelLayerOrGroup } from "@nova/constants"

type HotspotHeatmapLayerDataType = AnyAction

type _HotspotHeatmapLayerProps = {
    getFilterValue: (d: HotspotHeatmapLayerDataType) => number
    filterRange?: [number, number]
    sunlight: boolean
    entityMap: Record<string, SidePanelLayerOrGroup>
}

type HotspotHeatmapLayerProps<DataType = HotspotHeatmapLayerDataType> =
    HeatmapLayerProps<DataType> & _HotspotHeatmapLayerProps

const defaultProps: DefaultProps<HotspotHeatmapLayerProps> = {
    id: "heatmapLayer",
    radiusPixels: 20,
    weightsTextureSize: 1000,
    debounceTimeout: 750,
    getWeight: 1,
    aggregation: "SUM",
    data: [],
}

export default class HotspotHeatmapLayer<
    DataType = HotspotHeatmapLayerDataType,
    ExtraPropsType extends object = HotspotHeatmapLayerProps,
> extends HeatmapLayer<DataType, ExtraPropsType> {
    static defaultProps = defaultProps
    static layerName = "HotspotHeatmap"
}
